import { v1 as uuidv1 } from "uuid";
import moment from "moment";
export function formatCurrencyNoD_C(val) {
  const cv = parseInt(val);
  const res =
    cv.toLocaleString("it-IT", { style: "currency", currency: "VND" }) || "";
  return res.slice(0, -3);
}
export function addProduct_C(products, type = "tutor", listSKU) {
  if (type === "tutor") {
    products.push({
      type: "tutor",
      curriculumId: null,
      teacherType: null,
      package: null,
      productId: null,
      quantity: null,
      price: null,
      discount: 0,
      intoMoney: null,
      customerId: null,
      isNew: false,
      isExtend: false,
      packageOptions: [],
      products: listSKU,
      maxPrice: null,
      minPrice: null,
      priceType: "unchanged",
      productName: null,
      campaigns: [],
      listlevels: [],
      pricePerLesson: null,
      idBlock: uuidv1(),
    });
  }
  if (type === "duo") {
    products.push({
      subjectId: null,
      gradeId: null,
      numberOfSection: null,
      productId: null,
      activationType: null,
      duration: null,
      quantity: 1,
      price: null,
      discount: null,
      intoMoney: null,
      customerId: null,
      isNew: false,
      isExtend: false,
      products: listSKU,
      type,
      productName: null,
      priceType: "unchanged",
      campaigns: [],
      activeType: null,
      idBlock: uuidv1(),
    });
  }
  if (type === "combo") {
    products.push({
      type,
      categoryId: null,
      numberOfSection: null,
      productId: null,
      quantity: 1,
      price: null,
      isNew: false,
      isExtend: false,
      discount: null,
      intoMoney: null,
      customerId: null,
      products: listSKU,
      productName: null,
      priceType: "unchanged",
      campaigns: [],
      idBlock: uuidv1(),
    });
  }
}
export function verifyDataProduct(self, products) {
  const checkData = products.find((item) => !item.isNew && !item.isExtend);
  if (checkData) {
    self.$swal({
      icon: "error",
      title: "Thông báo",
      text: "Chưa chọn Bán mới | Gia hạn",
    });
    return true;
  }
  const checkData2 = products.find((item) => !item.price && item.price != 0);
  if (checkData2) {
    self.$swal({
      icon: "error",
      title: "Thông báo",
      text: "Chưa nhập đơn giá",
    });
    return true;
  }
  const checkData3 = products.find((item) => !item.activeType && item.type === "duo");
  if (checkData3) {
    self.$swal({
      icon: "error",
      title: "Thông báo",
      text: "Chưa chọn phương thức kích hoạt",
    });
    return true;
  }
  let hasDuplicates = products.some(
    (product, index, tem) =>
      tem.findIndex(
        (t) =>
          t.productId === product.productId &&
          t.customerId === product.customerId
      ) !== index && product.type !== "tutor"
  );
  if (hasDuplicates) {
    self.$swal({
      title: "Thông báo",
      html:
        "Sản phẩm khóa học và combo chưa hỗ trợ tách dòng cho cùng con. Vui lòng tách đơn cho Khóa học hoặc nhập Số gói cho combo nếu mua nhiều",
      icon: "error",
    });
    return true;
  }
  return false;
}
export function  formatCurrency(val) {
  const cv = parseInt(val);
  const res = cv.toLocaleString('it-IT', {style : 'currency', currency : 'VND'}) || '';

  return res.slice(0, -3) + ' (đ)';
}
export function formatDateDMY2(value) {
  if (value)
    return moment(value).format("DD/MM/YYYY")
}
